import { schema } from "normalizr";
import { MediaSchema } from "./media";

export const MediaArraySchema = new schema.Array(MediaSchema);
